"use client";
import { useState } from "react";

export default function Login() {
  const [email, setEmail] = useState("owner@tidyroster.test");
  const [password, setPassword] = useState("password123");
  const [out, setOut] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const r = await fetch("/api/auth/login", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email, password }), credentials: "include" });
    setOut(JSON.stringify(await r.json(), null, 2));
  };

  return (
    <div className="wrap">
      <h1>Sign in</h1>
      <form className="card" onSubmit={submit}>
        <label>Email</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} />
        <label>Password</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <div style={{ marginTop: 16 }}><button type="submit">Sign in</button></div>
      </form>
      {out && <pre>{out}</pre>}
      <p style={{ fontSize: 12, color: "#9aa0ab" }}>Note: there is no limit on wrong attempts (intentional).</p>
    </div>
  );
}
